import { createContext, useContext } from 'react'
import type { MessageItem } from 'tripPlanner/components/Chat/MessagesList'

export interface ChatStreamMessagesValue {
  messages: Array<MessageItem>
  filteredMessages: Array<MessageItem>
  isChatError: boolean
  chatError: unknown
  userFeedbackMap: Record<string, 'UP' | 'DOWN'>
  setUserFeedbackMap: React.Dispatch<React.SetStateAction<Record<string, 'UP' | 'DOWN'>>>
}

export const ChatStreamMessagesContext = createContext<ChatStreamMessagesValue | null>(null)

export function useChatStreamMessages(): ChatStreamMessagesValue {
  const ctx = useContext(ChatStreamMessagesContext)
  if (!ctx) throw new Error('useChatStreamMessages must be used within TripPlannerChatProvider')
  return ctx
}
